import sapBusinessOne from "./sap";
import zohoCreator from "./zohoCreator";
import odooPartner from "./odoo";
import erpServices from "./erp";
import mobileAppServices from "./mobileApp";
import webAppServices from "./webApp";
import uiUxServices from "./uiUx";
import aiServices from "./ai";

const servicesConfig = {
  ...sapBusinessOne,
  ...zohoCreator,
  ...odooPartner,
  ...erpServices,
  ...mobileAppServices,
  ...webAppServices,
  ...uiUxServices,
  ...aiServices,
};

export default servicesConfig;
